import { Component, inject, OnInit } from "@angular/core";
import { TreeNode } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ConfigService } from "src/app/common/services/config.service";
import { PredefinedPrompt, PromptModel } from "src/app/modules/prompts/models/prompt-template.model";
import { PromptsService } from "src/app/modules/prompts/services/prompts.service";

@Component({
  templateUrl: "./prompt-node-editor.component.html",
  styleUrls: ["./prompt-node-editor.component.scss"],
})
export class PromptNodeEditorComponent implements OnInit {
  label = $localize`:@@prompt_node_editor_new_node_default:Nouveau noeud`;
  action!: "add" | "edit";
  protected readonly ref = inject(DynamicDialogRef);
  protected readonly configService = inject(ConfigService);
  protected readonly promptsService = inject(PromptsService);
  protected readonly dialogConfig: DynamicDialogConfig<{
    node: TreeNode<PredefinedPrompt>;
    action: "add" | "edit";
  }> = inject(DynamicDialogConfig);

  get dynamicButtonLabel(): string {
    return this.action === "add"
      ? $localize`:@@prompt_node_editor_add_button_label:Ajouter`
      : $localize`:@@prompt_node_editor_save_button_label:Sauvegarder`;
  }

  ngOnInit(): void {
    this.action = this.dialogConfig.data!.action;
    const node = this.dialogConfig.data!.node;

    if (this.action === "edit") {
      this.label = node?.label ?? "";
    } else {
      this.label = $localize`:@@prompt_node_editor_new_node_label:Nouveau noeud`;
    }
  }

  async savePrompt(): Promise<void> {
    const p = this.dialogConfig.data!.node;
    let newNode: PromptModel | undefined;

    if (this.action === "add") {
      newNode = await this.promptsService.addTemplateNode(p.data!.id, this.label);
    } else if (this.action === "edit") {
      newNode = await this.promptsService.editTemplateNode(p.data!.id, this.label);
    }

    this.ref.close({
      node: {
        label: this.label,
        data: newNode?.predefinedPrompts,
      },
    });
  }
}
